import * as angular from 'angular';
import { HttpService } from '../../../../app.common/modules/api/http.service';
import { IPaginationFilter } from '../../../../app.common/modules/common/models';
import { BlobService } from '../../../../app.common/modules/common/services/blob.service';
import { RetailerService } from '../../api/retailer.service';
import { PhysicalProductMetadata } from '../../core';
import {
    IBundleItem,
    IBundleList,
    ICategoryFilter,
    ICategoryItems,
    ICreateBundleRequest
} from '../models/models';

export class BundlesService {
    public static $inject = [
        'http',
        'retailerService',
        'blobService'
    ];

    constructor(
        private http: HttpService,
        private retailerService: RetailerService,
        private blobService: BlobService
    ) {
    }

    public getBundleList(filter: IPaginationFilter): Promise<IBundleList> {
        return this.http.get<IBundleList>(this.retailerService.bundles(), { params: filter });
    }

    public getBundle(bundleID: number): Promise<IBundleItem> {
        return this.http.get<IBundleItem>(this.retailerService.bundleItem(bundleID));
    }

    public getLogoImageUrl(logoID: number, width?: number, height?: number): string {
        return this.retailerService.bundleImage(logoID, width, height);
    }

    public uploadLogoImage = (dataUri: string): angular.IPromise<number> => {
        const fd = new FormData();
        fd.append('FileImage', this.blobService.dataUriToBlob(dataUri));
        return this.http.post<number>(this.retailerService.storeBundleImage(), fd, {
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
        });
    }

    public removeLogoImage(logoID: number): angular.IPromise<void> {
        return this.http.delete(this.retailerService.bundleImage(logoID));
    }

    public getVariationImageUrl(id: string): string {
        return this.retailerService.getProductImageUrl(id, 48, 48);
    }

    public createBundle(bundle: ICreateBundleRequest): angular.IPromise<void> {
        return this.http.post(this.retailerService.bundles(), bundle);
    }

    public updateBundle(id: number, bundle: ICreateBundleRequest): angular.IPromise<void> {
        return this.http.put(this.retailerService.bundleItem(id), bundle);
    }

    public deleteBundle(id: number): Promise<void> {
        return this.http.delete(this.retailerService.bundleItem(id));
    }

    public getCategories(filter: ICategoryFilter): Promise<ICategoryItems> {
        return this.http.get<ICategoryItems>(this.retailerService.getCategoriesWithItemTypes(), { params: filter });
    }

    public fillSizeAndColourNames(bundle: IBundleItem, metadata: PhysicalProductMetadata) {
        if (bundle) {
            bundle.Components.forEach((component) => {
                component.Variations.forEach((variation) => {
                    let names = metadata.CategoryVariantFieldsNames[variation.CategoryID];
                    if (!names) {
                        names = metadata.DefaultVariantFieldsName;
                    }
                    variation.SizeName = names.SizeName ? names.SizeName : null;
                    variation.ColourName = names.ColourName ? names.ColourName : null;
                });
            });
        }
    }
}

angular
    .module('naut')
    .service('bundlesService', BundlesService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/bundles/services/bundles.service.ts